<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapGetters([ 'isPC' ])
  },
  created () {
    this.setIsPc()
    this.calcFontSize()
    window.onresize = () => {
      this.setIsPc()
      this.calcFontSize()
    }
  },
  methods: {
    setIsPc () {
      if (/(Android|iPhone|iPad|iPod|iOS|SymbianOS|Windows Phone)/i.test(navigator.userAgent)) {
        this.$store.commit('SET_IS_PC', false)
      } else if (window.matchMedia('(max-width:960px)').matches) {
        this.$store.commit('SET_IS_PC', false)
      } else {
        this.$store.commit('SET_IS_PC', true)
      }
    },
    calcFontSize () {
      if (this.isPC) {
        document.getElementsByTagName('html')[0].style.fontSize = (window.innerWidth - 16) / 13.66 + 'px'
      } else {
        document.getElementsByTagName('html')[0].style.fontSize = window.innerWidth / 3.75 + 'px'
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue